<template>
  <div class="l-row">
    <form-group :label="$t('color.label')">
      <multiselect
        v-model="newItem.from.color"
        :options="from.colors"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('color.label')" :columns="3">
      <multiselect
        v-model="newItem.to.color"
        :options="to.colors"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      newItem: {
        from: {
          color: null
        },
        to: {
          color: null
        }
      },
      from: {
        colors: []
      },
      to: {
        colors: []
      },
      items: [],
      alreadyExists: false,
      showItem: [],
      loaderColorsEcommerce: true,
      loaderColorsMarketplace: true,
      cloneColors: null
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getColors(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(colors => {
          this.from.colors = colors
          this.loaderColorsEcommerce = false
          this.hideItem()
          this.$emit('loading', this.loaderColorsEcommerce || this.loaderColorsMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as cores da Moovin.', 'Erro'))

      api.netshoes.getColors()
        .then(colors => {
          this.to.colors = colors
          this.loaderColorsMarketplace = false
          this.$emit('loading', this.loaderColorsEcommerce || this.loaderColorsMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as cores da Netshoes.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneColors) {
          this.cloneColors = cloneDeep(this.from.colors)
        }

        this.from.colors = cloneDeep(this.cloneColors)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.colors.indexOf(item.from.color)
          if (index !== -1) {
            this.from.colors.splice(index, 1)
          }
        }
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            color: this.newItem.from.color
          },
          to: {
            color: this.newItem.to.color
          }
        }

        if (item.from.color.toLowerCase() === item.to.color.toLowerCase()) {
          notifier.warning('Você não precisa fazer predefinição de itens iguais.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.color === item.from.color &&
            itemPreset.to.color === item.to.color
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'active': this.preset.active,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.color' () {
        this.emitEnabledAdd()
      },
      'newItem.to.color' () {
        this.emitEnabledAdd()
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// ColorAddItem.vue?4d90431a